// apifetch.js
// **** autor: Walcledson de Paula ****
// **** 12-09-24 | 13h26
// **** atualizado1: ****



import { encryptPass } from "./cryptosenha";
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API_URL;
const BA_USERNAME = process.env.REACT_APP_BA_USERNAME;
// const BA_PASSWORD = encryptPass(process.env.REACT_APP_BA_PASSWORD);

// const authString = btoa(`${BA_USERNAME}:${BA_PASSWORD}`); // Base64 para a autenticação Basic
const authString = btoa(`${BA_USERNAME}:${encryptPass(process.env.REACT_APP_BA_PASSWORD)}`); // Base64 para a autenticação Basic

// Função para fazer o fetch com configuração global
async function apifetch(endpoint, options = {}) {
    const url = `${API_URL}${endpoint}`;

    const defaultOptions = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${authString}`,
            'Accept': '*/*'
        },
        timeout: 30000, // Timeout de 30 segundos
        ...options // Combina as opções fornecidas com as padrões
    };

    // Configuração de timeout para o fetch
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), defaultOptions.timeout);

    try {
        const response = await fetch(url, {
            ...defaultOptions,
            signal: controller.signal, // Abort signal para o timeout
        });
        clearTimeout(timeoutId); // Limpa o timeout se a requisição for bem-sucedida

        if (!response.ok) {
            const errorData = await response.json();
            handleErrorResponse(response.status, errorData); // Tratamento de erro centralizado
            throw new Error(errorData.retorno || errorData.message || 'Erro desconhecido');
        }

        return await response.json(); // Retorna a resposta processada

    } catch (error) {
        clearTimeout(timeoutId);
        if (error.name === 'AbortError') {
            Swal.fire('Erro de Conexão', 'A conexão demorou muito para responder. Tente novamente mais tarde.', 'error');
        } else {
            Swal.fire('Erro', error.message || 'Ocorreu um erro. Tente novamente.', 'error');
        }
        throw error; // Propaga o erro para que o chamador possa lidar com ele
    }
}

// Função de tratamento de erros, semelhante ao que você faz no interceptor do Axios
function handleErrorResponse(status, data) {
    let errorMessage = 'Ocorreu um erro. Por favor, tente novamente mais tarde.';

    switch (status) {
        case 400:
            errorMessage = data.retorno || data.message || 'Requisição inválida.';
            break;
        case 401:
            errorMessage = 'Não autorizado. Faça login novamente.';
            break;
        case 403:
            errorMessage = 'Acesso proibido.';
            break;
        case 404:
            errorMessage = 'Recurso não encontrado.';
            break;
        case 500:
            errorMessage = data.retorno || data.message || 'Erro interno do servidor.';
            break;
        default:
            errorMessage = data.retorno || data.message || errorMessage;
    }

    Swal.fire('Erro', errorMessage, 'error');
}

export { apifetch };
